"use client";

import { cn } from "@jesus-central-church/shared";
import { Button } from "../button";

export interface EventsFooterCtaProperties {
  className?: string;
}

export function EventsFooterCta({ className }: EventsFooterCtaProperties) {
  return (
    <div className={cn("bg-strategy-gold", className)}>
      <div className="container mx-auto px-6 py-16 text-center md:px-12">
        <h2 className="mb-4 font-extrabold text-4xl tracking-tight text-freedom uppercase md:text-5xl">
          Meedoen?
        </h2>
        <p className="mx-auto mb-8 max-w-xl text-lg text-freedom/80">
          Word onderdeel van onze community. Ontdek hoe je kunt groeien, dienen
          en verbinden.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Button href="/connect" colorScheme="freedom" size="large">
            Connect Groepen
          </Button>
          <Button
            href="/vrijwilligers"
            colorScheme="freedom"
            variant="outline"
            size="large"
          >
            Vrijwilligen
          </Button>
          <Button
            href="/alpha"
            colorScheme="freedom"
            variant="outline"
            size="large"
          >
            Alpha Cursus
          </Button>
        </div>
      </div>
    </div>
  );
}
